import axios from "axios";
import MenuApi from "./menu";
import AuthApi from "./auth";
import TransactionApi from "./transaction";
import UserApi from "./user";
import OrderApi from "./order";
import { toast } from "react-hot-toast";

export const baseURL = process.env.REACT_APP_API_URL + "api";

export const http = axios.create({ baseURL });

export const setAuthToken = (authToken: string) => (http.defaults.headers.common["Authorization"] = authToken);

http.interceptors.request.use((config) => {
	config.headers.Authorization = localStorage.getItem("genius-order:authToken");
	return config;
});

http.interceptors.response.use(
	(res) => res,
	(error) => {
		if (error.response.status === 403 || error.response.status === 401) {
			window.location.assign("/login");
			localStorage.removeItem("genius-order:authToken");
		}
		error?.response?.data?.detail && toast.error(error?.response?.data?.detail);
		throw error;
	}
);

const api = {
	menu: new MenuApi(http),
	auth: new AuthApi(http),
	user: new UserApi(http),
	order: new OrderApi(http),
	transaction: new TransactionApi(http),
};

export default api;
